import React, { useState, useEffect, useRef } from "react";
import RecruitmentRequirements from "./RecruitmentRequirements";
import "./style.css";
import { Form } from "antd";
import moment from "moment";
import { authAxios } from "../../../utils";
import Cookies from "universal-cookie";
import {
  url_detail_recruitment,
  url_get_recruitment,
  url_get_detail_cv,
  url_export_recruitment,
} from "../../../constants";
import { EyeOutlined, FileAddOutlined } from "@ant-design/icons";
import ModalViewRecruitment from "./ViewRecruitmentRequirement/index";
import { openNotificationWithIcon } from "../../Function";
import ModalAddCandidate from "../candidateManagement/addCanditate/index";
import { useSelector } from "react-redux";
import fnFileDownload from "js-file-download";

const cookies = new Cookies();

const ActionButtonColumns = ({
  showModalViewRecruitment,
  showModalAddCandidate,
  record,
}) => {
  return (
    <>
      <EyeOutlined
        onClick={() => showModalViewRecruitment(record)}
        className="styleIcon"
      />
      {/* <Button
        shape="circle"
        icon={<EyeOutlined />}
        onClick={() => showModalViewRecruitment(record)}
      ></Button> */}
      <FileAddOutlined
        onClick={() => showModalAddCandidate(record)}
        className="styleIcon"
      />
      {/* <Button
        shape="circle"
        icon={<FileAddOutlined />}
        onClick={() => showModalAddCandidate(record)}
      ></Button> */}
    </>
  );
};

const index = () => {
  const [form] = Form.useForm();
  const [currentBP, setCurrentBP] = useState([]);
  const [treeDataBP, setTreeDataBP] = useState([]);
  const [dataRecruitment, setDataRecruitment] = useState([]);
  const [pager, setPager] = useState({ pageSize: 10, count: 0, current: 1 });
  const [isModalViewRecruitment, setIsModalViewRecruitment] = useState(false);

  // const [listDepartment, setListDepartment] = useState([]);
  // const [listStatus, setListStatus] = useState([]);
  const [listUserReceived, setListUserReceived] = useState([]);
  const [listUserHR, setListUserHR] = useState([]);
  const [listWorkLocation, setListWorkLocation] = useState([]);
  const [dataDetail, setDataDetail] = useState([]);
  const [isDisableForm, setIsDisableForm] = useState(true);
  const [uploadFileRec, setUploadFileRec] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateSearch, setDateSearch] = useState([
    moment(new Date()).subtract(6, "months"),
    moment(new Date()),
  ]);
  const [isModalOpenAddCandidate, setIsModalOpenAddCandidate] = useState(false);
  const [listCandidateSource, setListCandidateSource] = useState([]);
  const [listEducationLevel, setListEducationLevel] = useState([]);
  const [listLanguageSkill, setListLanguageSkill] = useState([]);
  const [uploadFileCV, setUploadFileCV] = useState(null);

  const ls_city = useSelector((state) => state.user.ls_city);
  const ls_department = useSelector((state) => state.user.ls_department);
  const ls_ticket_status = useSelector((state) =>
    state.user.ls_ticket_status.filter((item) =>
      [2, 3, 4, 6, 7].includes(item.id)
    )
  );
  // console.log(ls_ticket_status);

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      fixed: "left",
      width: 50,
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
    },
    {
      title: "Mã Yêu Cầu",
      dataIndex: "ticket_code",
      key: "ticket_code",
      filterKey: "ticket_code",
      // className: "highlight",
      type: "text",
      canSearch: true,
      fixed: "left",
      width: 130,
      render: (value, item, index) => (
        <a
          href={"/tickets/" + item.link_ticket.split("/").slice(-1)[0]}
          title={item.id}
        >
          {value}
        </a>
      ),
    },
    {
      title: "Link Tạo CV",
      dataIndex: "link_cv",
      key: "link_cv",
      filterKey: "link_cv",
      className: "highlight",
      type: "text",
      canSearch: true,
      ellipsis: true,
      align: "center",
      width: 200,
      render: (value, item, index) => (
        <a href={"/cv/" + value} target="_blank">
          {value}
        </a>
      ),
    },
    {
      title: "Tiêu Đề",
      dataIndex: "title",
      key: "title",
      filterKey: "title",
      className: "highlight",
      type: "text",
      render: (text) => (
        <div
          style={{
            maxHeight: "70px",
            overflowY: "auto",
            whiteSpace: "normal",
          }}
        >
          {text}
        </div>
      ),
      width: 250,
      ellipsis: true, // Bật tính năng hiển thị "..."
      canSearch: true,
    },
    {
      title: "Vị trí tuyển dụng",
      dataIndex: "rec_position",
      key: "rec_position",
      filterKey: "rec_position",
      className: "highlight",
      type: "text",
      render: (text) => (
        <div
          style={{
            maxHeight: "70px",
            overflowY: "auto",
            whiteSpace: "normal",
          }}
        >
          {text}
        </div>
      ),
      width: 170,
    },

    {
      title: "Bộ Phận",
      dataIndex: "department_recruited_name",
      key: "department_recruited_name",
      filterKey: "department_recruited_name",
      className: "highlight",
      type: "text",
      width: 80,
    },
    {
      title: "Số Lượng",
      dataIndex: "quantity",
      key: "quantity",
      filterKey: "quantity",
      className: "highlight",
      type: "text",
      width: 80,
    },
    {
      title: "Ngày Hết Hạn",
      dataIndex: "duedate",
      key: "duedate",
      filterKey: "duedate",
      className: "highlight",
      type: "text",
      width: 120,
      render: (value, item, index) =>
        moment(value, "YYYY-MM-DD").format("DD/MM/YYYY"),
    },

    // {
    //   title: "Người Cập Nhật",
    //   dataIndex: "user_update_name",
    //   key: "user_update_name",
    //   filterKey: "user_update_name",
    //   className: "highlight",
    //   type: "text",
    //   canSearch: true,
    //   width: 150,
    // },
    {
      title: "Người Xử Lý",
      dataIndex: "detail_user_received",
      key: "detail_user_received",
      filterKey: "detail_user_received",
      className: "highlight",
      type: "text",
      canSearch: true,
      width: 150,
      // render: (text) => <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>{ text.map((item) => item.username).join(", ")}</div>,
      render: (text) => (
        <div
          style={{
            maxHeight: "70px",
            overflowY: "auto",
            whiteSpace: "normal",
          }}
        >
          {text.map((item) => item.username).join(", ")}
        </div>
      ),
    },
    {
      title: "Trạng Thái",
      dataIndex: "ticket_status_name",
      key: "ticket_status_name",
      filterKey: "ticket_status_name",
      className: "highlight",
      type: "text",
      width: 120,
      render: (value, item) => (
        <a
          style={{
            backgroundColor: item.color,
            color: "#ffffff",
            padding: "3px 5px 3px 5px",
            borderRadius: "5px",
          }}
        >
          {value}
        </a>
      ),
    },
    {
      title: "Thao Tác",
      dataIndex: "Thao Tác",
      key: "Thao Tác",
      filterKey: "Thao Tác",
      className: "highlight",
      type: "text",
      width: 100,
      fixed: "right",
      render: (_, record, index) => (
        <ActionButtonColumns
          showModalViewRecruitment={showModalViewRecruitment}
          showModalAddCandidate={showModalAddCandidate}
          record={record}
        />
      ),
    },
  ];

  const appliedFilters = useRef({});
  const listRequestId = useRef(0);

  const fetchListRecruitment = (params = {}) => {
    appliedFilters.current = params;
    const requestId = ++listRequestId.current;
    setLoading(true);

    authAxios(cookies.get("token"))
      .get(url_get_recruitment, { params: params })
      .then((res) => {
        if (requestId !== listRequestId.current) return;

        if (res.data) {

        }
        setPager({
          current: params.page,
          pageSize: params.page_size,
          count: res.data.count,
        });

        setDataRecruitment(res.data.results);
        // setListStatus(res.data.list_status);
        // setListDepartment(res.data.department);
        setListUserReceived(res.data.list_user_received);
        setListUserHR(res.data.list_user_hr);

        // setListWorkLocation(res.data.work_location);
        setListCandidateSource(res.data.list_candidate_source);
        setListEducationLevel(res.data.list_education_level);
        setListLanguageSkill(res.data.ls_language_skill);
        setLoading(false);
      })
      .catch((err) => {
        if (requestId !== listRequestId.current) return;
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);

        // openNotificationWithIcon('success','Thành công','');
      });
  };

  // const fetchListDepartment = (params = {}) => {
  //   authAxios(cookies.get("token"))
  //     .get(url_get_list_department, { params: params })
  //     .then((res) => {
  //       setListBoPhanAll(res.data);
  //     })
  //     .catch((err) => {
  //       if (err.response.status === 401) {
  //         window.location = "/login";
  //       }
  //       // openNotificationWithIcon('success','Thành công','');
  //     });
  // };

  // const fetchListStatusTicket = (params = {}) => {
  //   authAxios(cookies.get("token"))
  //     .get(url_get_list_status_ticket, { params: params })
  //     .then((res) => {
  //       setListValueProfileStatus(res.data.results);
  //     })
  //     .catch((err) => {
  //       if (err.response.status === 401) {
  //         window.location = "/login";
  //       }
  //       // openNotificationWithIcon('success','Thành công','');
  //     });
  // };

  useEffect(() => {
    // var setDateFomate = [
    //   moment(new Date()).subtract(6, "months"),
    //   moment(new Date()),
    // ];
    form.setFieldsValue({
      datepicker: dateSearch,
    });
    fetchListRecruitment({
      page: pager.current || 1,
      page_size: pager.pageSize,
      from_date: dateSearch[0].format("YYYY-MM-DD"),
      to_date: dateSearch[1].format("YYYY-MM-DD"),
    });
  }, [form]);

  const setRangeDate = (value) => {
    form.setFieldsValue({ datepicker: value });
  };

  const onChangeBP = (value) => {
    if (value.length > 0) {
      setCurrentBP(value);
      form.setFieldsValue({
        department_recruited: value,
      });
    } else {
      setCurrentBP([]);
      form.setFieldsValue({
        department_recruited: undefined,
      });
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBP.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBP([]);
                }
              }}
              className="btn-tree-select"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBP(ls_department.map((item) => item.id));
                }
              }}
              className="btn-tree-select"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: false,
        className: "btn-tree-select",
      },
      ...treeDataBP,
    ],
    value: treeDataBP.length > 0 ? currentBP : undefined,
    onChange: onChangeBP,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 3,
    placeholder: "Chọn bộ phận",
    disabled: loading,
    allowClear: true,
    showSearch: false,
  };

  useEffect(() => {
    const treeDataBP = ls_department.map((item) => {
      return {
        title: item.name,
        value: item.id,
        key: item.id,
      };
    });
    setTreeDataBP(treeDataBP);
  }, [ls_department]);

  const showModalViewRecruitment = (record) => {
    authAxios(cookies.get("token"))
      .get(url_detail_recruitment(record.id))
      .then((res) => {
        setDataDetail(res.data);
        setIsModalViewRecruitment(true);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
      });
  };

  const onFinish = (values) => {
    // Chức năng tìm kiếm
    setDateSearch(values.datepicker);
    form.setFieldsValue({
      datepicker: values.datepicker,
    });

    fetchListRecruitment({
      page: 1,
      page_size: pager.pageSize,
      from_date: values.datepicker[0].format("YYYY-MM-DD"),
      to_date: values.datepicker[1].format("YYYY-MM-DD"),
      department_recruited:
        values.department_recruited === undefined
          ? undefined
          : values.department_recruited.join(", "),
      ticket_status: values.ticket_status,
      title: values.title,
      user_received: values.user_received,
      // work_location: values.work_location,
    });
  };

  const onFinishEdit = (values) => {
    // Chức năng chỉnh sửa
    var FormData = require("form-data");
    var data = new FormData();
    data.append("values", JSON.stringify(values));
    if (uploadFileRec != undefined) {
      data.append("file_upload", uploadFileRec[0].originFileObj);
    }
    let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .put(url_detail_recruitment(dataDetail.results.id), data)
      .then((res) => {
        fetchListRecruitment({
          page: pager.current || 1,
          page_size: pager.pageSize,
          from_date: dateSearch[0].format("YYYY-MM-DD"),
          to_date: dateSearch[1].format("YYYY-MM-DD"),
          department_recruited:
            get_form["department_recruited"] === undefined
              ? undefined
              : get_form["department_recruited"].join(", "),
          ticket_status: get_form["ticket_status"],
          title: get_form["title"],
          user_received: get_form["user_received"],
          work_location: get_form["work_location"],
        });
        openNotificationWithIcon("success", "Lưu thông tin thành công", "");
        onCancelViewRecruitment();
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
      });
  };

  const onFinishAddCV = (values) => {
    // Thêm CV
    if (values.birthday != undefined) {
      values["birthday"] = values.birthday.format("YYYY-MM-DD");
    }
    values["department_recruited"] = dataDetail.results.department_recruited;

    var FormData = require("form-data");
    var data = new FormData();
    data.append("values", JSON.stringify(values));
    if (uploadFileCV != undefined) {
      data.append("file_upload", uploadFileCV[0].originFileObj);
    }

    // let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .post(url_get_detail_cv(dataDetail.results.id), data)
      .then((res) => {
        // fetchListRecruitment({
        //   page: pager.current || 1,
        //   page_size: pager.pageSize,
        //   from_date: dateSearch[0].format("YYYY-MM-DD"),
        //   to_date: dateSearch[1].format("YYYY-MM-DD"),
        //   department_recruited:
        //     get_form["department_recruited"] === undefined
        //       ? undefined
        //       : get_form["department_recruited"].join(", "),
        //   ticket_status: get_form["ticket_status"],
        //   title: get_form["title"],
        //   user_received: get_form["user_received"],
        //   work_location: get_form["work_location"],
        // });
        openNotificationWithIcon("success", "Tạo thông tin thành công", "");
        onCancelAddCandidate();
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
      });
  };

  const onCancelViewRecruitment = () => {
    setIsModalViewRecruitment(false);
  };

  const onCancelAddCandidate = () => {
    setIsModalOpenAddCandidate(false);
  };

  const handleChangeUpload = (info) => {
    setUploadFileRec(info.fileList);
    if (info.fileList.length === 0) {
      setUploadFileRec(null);
      form.setFieldsValue({
        name_file_recr: undefined,
      });
    }
  };

  const handleChangeUploadCV = (info) => {
    setUploadFileCV(info.fileList);
    if (info.fileList.length === 0) {
      setUploadFileCV(null);
    }
  };

  const showModalAddCandidate = (record) => {
    authAxios(cookies.get("token"))
      .get(url_detail_recruitment(record.id))
      .then((res) => {
        setDataDetail(res.data);
        setIsModalOpenAddCandidate(true);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
      });
  };

  const fileDownloadRecr = (values) => {
    setLoading(true);

    let current_date = moment(new Date());
    const filename =
      "Report_Recruitment__" + current_date.format("YYYYMMDD") + ".xlsx";
    let get_form = form.getFieldsValue();
    var FormData = require("form-data");
    var data = new FormData();
    // Lấy tương tự phần tìm kiếm
    data.append("page", pager.page);
    data.append("page_size", pager.pageSize);
    data.append("from_date", dateSearch[0].format("YYYY-MM-DD"));
    data.append("to_date", dateSearch[1].format("YYYY-MM-DD"));
    data.append(
      "department_recruited",
      get_form["department_recruited"] === undefined
        ? undefined
        : get_form["department_recruited"].join(", ")
    );
    data.append("ticket_status", get_form["ticket_status"]);
    data.append("title", get_form["title"]);
    data.append("user_received", get_form["user_received"]);
    data.append("work_location", get_form["work_location"]);

    authAxios(cookies.get("token"))
      .post(url_export_recruitment, data, { responseType: "blob" })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fnFileDownload(blob, filename);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon(
          "error",
          "Không tải được danh sách. Bạn vui lòng thử lại."
        );
        setLoading(false);
      });
  };

  const handleChange = (pagination) => {
    fetchListRecruitment({
      ...appliedFilters.current,
      page_size: pagination.pageSize,
      page: pagination.current,
    });
  };

  return (
    <>
      <RecruitmentRequirements
        form={form}
        listStatus={ls_ticket_status}
        listUserReceived={listUserReceived}
        listUserHR={listUserHR}
        listWorkLocation={listWorkLocation}
        // onChangeBP={onChangeBP}
        currentBP={currentBP}
        // treeDataBP={treeDataBP}
        // treeData={treeData}
        columns={columns}
        dataRecruitment={dataRecruitment}
        setRangeDate={setRangeDate}
        onFinish={onFinish}
        tPropsConfig_BoPhan={tPropsConfig_BoPhan}
        dateSearch={dateSearch}
        fileDownloadRecr={fileDownloadRecr}
        pager={pager}
        handleChange={handleChange}
      />
      {isModalViewRecruitment && (
        <ModalViewRecruitment
          dataDetail={dataDetail}
          isModalViewRecruitment={isModalViewRecruitment}
          onCancelViewRecruitment={onCancelViewRecruitment}
          onFinishEdit={onFinishEdit}
          isDisableForm={isDisableForm}
          setIsDisableForm={setIsDisableForm}
          handleChangeUpload={handleChangeUpload}
          uploadFileRec={uploadFileRec}
          loading={loading}
        />
      )}

      {isModalOpenAddCandidate && (
        <ModalAddCandidate
          isModalOpenAddCandidate={isModalOpenAddCandidate}
          onCancelAddCandidate={onCancelAddCandidate}
          onFinishAddCV={onFinishAddCV}
          dataDetail={dataDetail}
          listCandidateSource={listCandidateSource}
          listEducationLevel={listEducationLevel}
          // listLanguageSkill={listLanguageSkill}
          handleChangeUploadCV={handleChangeUploadCV}
          uploadFileCV={uploadFileCV}
          ls_city={ls_city}
        />
      )}
    </>
  );
};

export default index;
